/**
 * Japanese (JPY base) cross-currency transactions for the multi-currency
 * use case. Foreign-currency rows carry their own symbol so the real
 * DataTable renders a ¥/$/€/£ mix; the transfer pair shows both sides via
 * `paired*`.
 */

/** @type {Array<import('../../mock-transactions.js').MockTransaction>} */
export const MOCK_CROSS_CURRENCY_TRANSACTIONS_JA = [
	{
		id: 'xcur-1',
		isTransferPair: true,
		date: '2026-08-05',
		type: 'Transfer',
		amount: 100000,
		description: '米国証券へ送金',
		accountId: 'acc-checking',
		accountName: 'みどり銀行',
		currency: 'JPY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		tagNames: '貯金',
		pairedType: 'Transfer',
		pairedAmount: 680,
		pairedCurrencySymbol: '$',
		pairedCurrencyDecimalPlaces: 2,
		pairedAccountName: '米国証券',
		pairedAccountId: 'acc-us',
		pairedDate: '2026-08-05',
	},
	{
		id: 'xcur-2',
		date: '2026-08-04',
		type: 'Deposit',
		amount: 350000,
		description: '給与',
		accountId: 'acc-checking',
		accountName: 'みどり銀行',
		currency: 'JPY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		tagNames: '収入',
	},
	{
		id: 'xcur-3',
		date: '2026-08-02',
		type: 'Purchase',
		amount: 89,
		description: 'ソフトウェア',
		accountId: 'acc-us',
		accountName: '米国証券',
		currency: 'USD',
		currencySymbol: '$',
		currencyDecimalPlaces: 2,
		tagNames: '仕事',
	},
	{
		id: 'xcur-4',
		date: '2026-07-29',
		type: 'Purchase',
		amount: 65,
		description: 'ベルリンのホテル',
		accountId: 'acc-eur',
		accountName: 'ユーロカード',
		currency: 'EUR',
		currencySymbol: '\u20AC',
		currencyDecimalPlaces: 2,
		tagNames: '旅行',
	},
	{
		id: 'xcur-5',
		date: '2026-07-25',
		type: 'Purchase',
		amount: 45,
		description: 'ロンドンの紅茶',
		accountId: 'acc-gbp',
		accountName: 'イギリス口座',
		currency: 'GBP',
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		tagNames: '食費',
	},
];
